import { setup } from "web/entrypoints/common/setup";
import "./css-the-edit";
import { theEditComponents } from "./the-edit";

setup(theEditComponents);
